import { Link } from 'react-router-dom';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Breadcrumb */}
      <div className="bg-gray-50 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 py-3">
          <nav className="flex items-center space-x-2 text-sm">
            <a href="https://soyproteinranking.com/" className="flex items-center text-blue-600 hover:text-blue-800">
              <img 
                src="https://medical-list.net/mouthpiece/assets/img/home-solid.svg" 
                alt="home" 
                className="w-4 h-4 mr-2"
              />
              トップ
            </a>
            <span className="text-gray-400">&gt;</span>
            <span className="text-gray-700">運営会社</span>
          </nav>
        </div>
      </div>

      {/* Header */}
      <header className="py-16 relative overflow-hidden">
        <div className="absolute left-0 top-1/2 -translate-y-1/2 w-48 h-48 opacity-10">
          <div className="grid grid-cols-8 gap-1">
            {Array.from({ length: 64 }).map((_, i) => (
              <div key={i} className="w-1 h-1 bg-blue-400 rounded-full"></div>
            ))}
          </div>
        </div>
        <div className="absolute right-0 top-1/2 -translate-y-1/2 w-48 h-48 opacity-10">
          <div className="grid grid-cols-8 gap-1">
            {Array.from({ length: 64 }).map((_, i) => (
              <div key={i} className="w-1 h-1 bg-blue-400 rounded-full"></div>
            ))}
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-4xl font-bold text-center text-gray-900">運営会社</h1>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 pb-20">
        {/* Company Information Section */}
        <div className="mb-16">
          <div className="border-t-4 border-blue-500 mb-8"></div>
          <h2 className="text-2xl font-bold text-gray-900 mb-8 pb-4 border-b-2 border-gray-200">
            運営会社情報
          </h2>
          <div className="bg-white border border-gray-300 rounded-lg p-8 shadow-sm">
            <div className="space-y-3 text-gray-700 leading-relaxed">
              <p><strong>会社名：</strong>株式会社PLUS</p>
              <p><strong>住所：</strong>060-0061 北海道札幌市中央区南1条西8丁目1-1 クリスタルタワー15F</p>
              <p><strong>問い合わせ：</strong>https://plus-company.jp/contact/</p>
              <p><strong>tel：</strong>011-211-5765</p>
            </div>
          </div>
        </div>

        {/* Disclaimer Section */}
        <div className="mb-12">
          <h3 className="text-xl font-bold text-gray-900 mb-6 pb-3 border-l-4 border-blue-500 pl-4">
            免責事項
          </h3>
          <div className="space-y-4 text-gray-700 leading-relaxed">
            <p>
              当サイトで紹介しているサービスや商品などは直接、当サイトが販売・提供するものではありません。<br />
              会員登録・資料請求・商品購入などは当サイトで紹介しているリンク先のサイトでのやり取りとなります。
            </p>
            <p>
              リンク先で商品などを購入する場合、価格・支払方法・詳細等は必ずリンク先の情報をご確認頂きますよう、お願い申し上げます。<br />
              リンク先のサービスを利用したことによるいかなる被害や損害に関しても、当サイトは一切の責任を負いません。
            </p>
          </div>
        </div>

        {/* Privacy Policy Section */}
        <div className="mb-12">
          <h3 className="text-xl font-bold text-gray-900 mb-6 pb-3 border-l-4 border-blue-500 pl-4">
            プライバシーポリシー
          </h3>
          <div className="space-y-4 text-gray-700 leading-relaxed">
            <p>
              ユーザーの皆様が閲覧・ご利用する際、当サイトでは以下のような情報を収集することがあります。<br />
              当サイトでは、ご訪問者様のプライバシーに関わる個人情報を保護することに細心の注意を払っています。
            </p>
          </div>
        </div>

        {/* Cookie Section */}
        <div className="mb-12">
          <h3 className="text-xl font-bold text-gray-900 mb-6 pb-3 border-l-4 border-gray-600 pl-4">
            Cookieについて
          </h3>
          <div className="space-y-4 text-gray-700 leading-relaxed">
            <p>
              Cookieとは、ユーザーの皆様がインターネットを利用してWebサイトを訪問した際に設定されます。<br />
              Webサイトの情報を一時的に保存しておく事で次回以降アクセス時のサイト表示速度をあげるなど、Webサイト訪問者の利便性のために使用されます。
            </p>
            <p>
              Cookieの取得を拒否したい場合には、お使いのブラウザの「ヘルプ」メニューをご覧になり、Cookieの送受信に関する設定を行ってください。ブラウザに保存されているCookieの削除や全面的にオフにすることもできます。
            </p>
            <p>
              ただし、Cookieはインターネットでの一般的な技術であり多くのサイトで使われているため、Cookieを全面的にオフにした場合、一部のサイトが正常に機能しなくなる可能性があります。
            </p>
            <p>
              当サイトでは、Google合同会社、yahoo株式会社を含む第三者配信事業者が提供するサービスにより、当サイトを訪問したユーザーのCookie情報を取得し、個人の情報が特定されない範囲内でターゲティング広告の配信を行うために利用します。
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
